export const REG_EXP_NOTATION =
  /\[(\s|[a-zà-úA-ZÀ-Ú0-9]|\/|:)*\]\([a-zA-Z0-9_\- ]*:@[a-zA-Z0-9_\-.]*\)/gi

export const REG_EXP_SPAN =
  /<span class="color[0-9]">(\s|[a-zà-úA-ZÀ-Ú0-9]|\/|:)*<\/span>/gi
